"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseSDK = exports.CONTRACT_TO_ABI = void 0;
var ethers_1 = require("ethers");
var lodash_1 = require("lodash");
var constants_1 = require("../constants");
//@ts-ignore
var IIdentity_min_json_1 = __importDefault(require("@gooddollar/goodprotocol/artifacts/abis/IIdentity.min.json"));
//@ts-ignore
var UBIScheme_min_json_1 = __importDefault(require("@gooddollar/goodprotocol/artifacts/abis/UBIScheme.min.json"));
//@ts-ignore
var GoodDollarStaking_min_json_1 = __importDefault(require("@gooddollar/goodprotocol/artifacts/abis/GoodDollarStaking.min.json"));
//@ts-ignore
var IGoodDollar_min_json_1 = __importDefault(require("@gooddollar/goodprotocol/artifacts/abis/IGoodDollar.min.json"));
var Faucet_min_json_1 = __importDefault(require("@gooddollar/goodprotocol/artifacts/abis/Faucet.min.json"));
var GReputation_min_json_1 = __importDefault(require("@gooddollar/goodprotocol/artifacts/abis/GReputation.min.json"));
var GoodReserveCDai_min_json_1 = __importDefault(require("@gooddollar/goodprotocol/artifacts/abis/GoodReserveCDai.min.json"));
//@ts-ignore
var deployment_json_1 = __importDefault(require("@gooddollar/goodprotocol/releases/deployment.json"));
exports.CONTRACT_TO_ABI = {
  Identity: IIdentity_min_json_1.default,
  UBIScheme: UBIScheme_min_json_1.default,
  GoodDollarStaking: GoodDollarStaking_min_json_1.default,
  GoodDollar: IGoodDollar_min_json_1.default,
  Faucet: Faucet_min_json_1.default,
  FuseFaucet: Faucet_min_json_1.default,
  GReputation: GReputation_min_json_1.default,
  GoodReserveCDai: GoodReserveCDai_min_json_1.default
};
var BaseSDK = /*#__PURE__*/function () {
  function BaseSDK(provider) {
    var _this = this;
    var contractsEnv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "production";
    _classCallCheck(this, BaseSDK);
    this.signer = undefined;
    this.provider = provider;
    var devEnv = contractsEnv.split("-")[0];
    devEnv = devEnv === "fuse" ? "development" : devEnv;
    this.env = constants_1.Envs[devEnv];
    this.contracts = deployment_json_1.default[contractsEnv];
    // console.log("baseSdk provider", { provider });
    provider.getNetwork().then(function (network) {
      if (network.chainId != _this.contracts.networkId) console.error("BaseSDK: provider chainId doesn't match env (".concat(contractsEnv, ") chainId. provider:").concat(network.chainId, " env:").concat(_this.contracts.networkId));
    }).catch(lodash_1.noop);
    try {
      var signer = provider.getSigner();
      signer.getAddress().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", void (_this.signer = signer));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (e) {
        console.warn("BaseSDK: provider has no signer", {
          signer: signer,
          provider: provider,
          e: e
        });
      });
    } catch (e) {
      console.warn("BaseSDK: provider has no signer", {
        provider: provider,
        e: e
      });
    }
  }
  _createClass(BaseSDK, [{
    key: "getContract",
    value: function getContract(contractName) {
      if (!this.contracts[contractName]) return;
      switch (contractName) {
        case "UBIScheme":
          return new ethers_1.Contract(this.contracts["UBIScheme"], exports.CONTRACT_TO_ABI["UBIScheme"].abi, this.signer || this.provider);
        case "Identity":
          return new ethers_1.Contract(this.contracts["Identity"], exports.CONTRACT_TO_ABI["Identity"].abi, this.signer || this.provider);
        case "GoodDollarStaking":
          return new ethers_1.Contract(this.contracts["GoodDollarStaking"], exports.CONTRACT_TO_ABI["GoodDollarStaking"].abi, this.signer || this.provider);
        case "GoodDollar":
          return new ethers_1.Contract(this.contracts["GoodDollar"], exports.CONTRACT_TO_ABI["GoodDollar"].abi, this.signer || this.provider);
        case "Faucet":
          return new ethers_1.Contract(this.contracts["Faucet"], exports.CONTRACT_TO_ABI["Faucet"].abi, this.signer || this.provider);
        case "GReputation":
          return new ethers_1.Contract(this.contracts["GReputation"], exports.CONTRACT_TO_ABI["GReputation"].abi, this.signer || this.provider);
        case "GoodReserveCDai":
          return new ethers_1.Contract(this.contracts["GoodReserveCDai"], exports.CONTRACT_TO_ABI["GoodReserveCDai"].abi, this.signer || this.provider);
        default:
          return new ethers_1.Contract(this.contracts[contractName], exports.CONTRACT_TO_ABI[contractName].abi, this.signer || this.provider);
      }
    }
  }]);
  return BaseSDK;
}();
exports.BaseSDK = BaseSDK;